export enum Permissions {
    AdministrationView = "Frends.Administration.View",
    ApiKeyManagementAdmin = "Frends.ApiKeyManagement.Admin",
    ApiManagementView = "Frends.ApiManagement.View",
    ApiManagementEdit = "Frends.ApiManagement.Edit",
    ApiManagementDeploy = "Frends.ApiManagement.Deploy",
    EnvironmentEdit = "Frends.Environment.Edit",
    EnvironmentAdmin = "Frends.Environment.Admin",
    EnvironmentVariablesEdit = "Frends.EnvironmentVariables.Edit",
    MonitoringRulesView = "Frends.MonitoringRules.View",
    MonitoringRulesEdit = "Frends.MonitoringRules.Edit",
    ProcessEdit = "Frends.Process.Edit",
    ProcessStart = "Frends.Process.Start",
    ProcessDeploy = "Frends.Process.Deploy",
    ProcessView = "Frends.Process.View",
    ProcessAdmin = "Frends.Process.Admin",
    ProcessInstanceEdit = "Frends.ProcessInstance.Edit",
    TaskView = "Frends.Task.View",
    TaskEdit = "Frends.Task.Edit",
    TaskAdmin = "Frends.Task.Admin",
    UserManagementAdmin = "Frends.UserManagement.Admin",
    OAuthApplicationManagementAdmin = "Frends.OAuthApplicationManagement.Admin",
    ProcessTemplateView = "Frends.ProcessTemplate.View",
    ProcessTemplateEdit = "Frends.ProcessTemplate.Edit",
    ApiMonitoringView = "Frends.ApiMonitoring.View",
    ApiMonitoringEdit = "Frends.ApiMonitoring.Edit",
    PrivateApplicationView = "Frends.PrivateApplication.View",
    PrivateApplicationEdit = "Frends.PrivateApplication.Edit",
    PrivateApplicationEditViewToken = "Frends.PrivateApplication.ViewToken",
    PersonalApplicationView = "Frends.PersonalApplication.View",
    ApiPolicyView = "Frends.ApiPolicy.View",
    ApiPolicyEdit = "Frends.ApiPolicy.Edit",
    AiView = "Frends.Ai.View",
    AiEdit = "Frends.Ai.Edit",
    AiAdmin = "Frends.Ai.Admin",
    WorkspacesAdmin = "Frends.Workspaces.Admin",
}

export const AllPermissionsTrue = {
    [Permissions.ApiManagementView]: true,
    [Permissions.ApiManagementEdit]: true,
    [Permissions.ApiManagementDeploy]: true,
    [Permissions.ProcessView]: true,
    [Permissions.ProcessEdit]: true,
    [Permissions.ProcessStart]: true,
    [Permissions.ProcessDeploy]: true,
    [Permissions.ProcessAdmin]: true,
    [Permissions.EnvironmentVariablesEdit]: true,
    [Permissions.AdministrationView]: true,
    [Permissions.EnvironmentEdit]: true,
    [Permissions.EnvironmentAdmin]: true,
    [Permissions.TaskView]: true,
    [Permissions.TaskEdit]: true,
    [Permissions.TaskAdmin]: true,
    [Permissions.MonitoringRulesView]: true,
    [Permissions.MonitoringRulesEdit]: true,
    [Permissions.UserManagementAdmin]: true,
    [Permissions.ApiKeyManagementAdmin]: true,
    [Permissions.ProcessInstanceEdit]: true,
    [Permissions.OAuthApplicationManagementAdmin]: true,
    [Permissions.ProcessTemplateView]: true,
    [Permissions.ProcessTemplateEdit]: true,
    [Permissions.PrivateApplicationView]: true,
    [Permissions.PrivateApplicationEdit]: true,
    [Permissions.PrivateApplicationEditViewToken]: true,
    [Permissions.PersonalApplicationView]: true,
    [Permissions.ApiPolicyView]: true,
    [Permissions.ApiPolicyEdit]: true,
    [Permissions.ApiMonitoringView]: true,
    [Permissions.ApiMonitoringEdit]: true,
    [Permissions.AiView]: true,
    [Permissions.AiEdit]: true,
    [Permissions.AiAdmin]: true,
    [Permissions.WorkspacesAdmin]: true,
};
